module.exports = __webpack_public_path__ + "static/welcome-icon-5cf29ce383894fb298aacc3386880338.svg";